import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import getLanguages from '../../api/oc_product/productDataManagement/colourMatching/get/getLanguageDetails';

// First, create the thunk
export const fetchLanguages = createAsyncThunk(
  'languages',
  async () => {
    try {
      const { data } = await getLanguages();
      return data;
    } catch (error) {
      return false;
    }
  },
);

const initialState = {
  languages: [],
};

const languagesSlice = createSlice({
  initialState,
  name: 'languages',
  reducers: {
    setLanguages: (state, action) => {
      state.languages = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchLanguages.fulfilled, (state, action) => action.payload);
  },
});

export const { setLanguages } = languagesSlice.actions;

export default languagesSlice.reducer;
